import SupermarketArea from './supermarket_area.vue';

export default SupermarketArea;
